export default __webpack_public_path__ + "static/media/loading.fe550ce9.gif";